import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'
import elementVariables from '@/styles/element-variables.scss'
import defaultSettings from '@/settings'

export interface ISettingsState {
  theme: string
  fixedHeader: boolean
  showSettings: boolean
  showTagsView: boolean
  showSidebarLogo: boolean
  sidebarTextTheme: boolean
  operationWidth: number      // 一个个操作栏宽度
  operationWidth2: number     // 两个操作栏宽度
  operationWidth3: number     // 三个操作栏宽度
  operationWidth4: number     // 四个操作栏宽度
  statusWidth: number         // 状态栏宽度
  orderStatusWidth: number    // 订单状态栏宽度
  orderStatusWidth2: number   // 代付、结算订单状态栏宽度
  notifyStatusWidth: number   // 通知状态栏宽度
  timeWidth: number           // 时间栏宽度
  feeWidth: number            // 费率栏宽度
  feeWidth2: number           // 费率栏宽度2
  openTimeWidth: number       // 开放时间栏宽度
  ipWidth: number             // ip栏宽度
  descriptionWidth: number    // 描述宽度
  contentWidth: number        // 内容宽度
  titleWidth: number          // title宽度
  nameWidth: number           // name宽度
}

@Module({ dynamic: true, store, name: 'settings' })
class Settings extends VuexModule implements ISettingsState {
  public theme = elementVariables.theme
  public fixedHeader = defaultSettings.fixedHeader
  public showSettings = defaultSettings.showSettings
  public showTagsView = defaultSettings.showTagsView
  public showSidebarLogo = defaultSettings.showSidebarLogo
  public sidebarTextTheme = defaultSettings.sidebarTextTheme
  public operationWidth = 90
  public operationWidth2 = 150
  public operationWidth3 = 220
  public operationWidth4 = 310
  public statusWidth = 120
  public orderStatusWidth = 120
  public orderStatusWidth2 = 170
  public notifyStatusWidth = 150
  public timeWidth = 220
  public handleTimeWidth = 120
  public feeWidth = 220
  public feeWidth2 = 320
  public openTimeWidth = 100
  public ipWidth = 150
  public descriptionWidth = 300
  public contentWidth = 300
  public titleWidth = 150
  public nameWidth = 150

  @Mutation
  private CHANGE_SETTING(payload: { key: string, value: any }) {
    const { key, value } = payload
    if (Object.prototype.hasOwnProperty.call(this, key)) {
      (this as any)[key] = value
    }
  }

  @Action
  public ChangeSetting(payload: { key: string, value: any}) {
    this.CHANGE_SETTING(payload)
  }
}

export const SettingsModule = getModule(Settings)
